import React, { useEffect, useState } from 'react'
import Image from '../../components/Image/Image';
import ImageViewer from '../../components/ImageViewer/ImageViewer';
import { FirebaseHelper } from '../../firebase-helper';
import './WallpapersPage.scss'

function WallpapersPage() {
  const firebaseHelperWallpapers = new FirebaseHelper("wallpapers");
  const wallpapersRef = firebaseHelperWallpapers.usersCollectionRef;

  const [wallpapers, setWallpapers] = useState([]);
  
  const [wallpapersColumn1, setWallpapersColumn1] = useState([]);
  const [wallpapersColumn2, setWallpapersColumn2] = useState([]);

  const [visible, setVisible] = useState(false);
  const [viewerWallpaper, setViewerWallpaper] = useState("");
  const [viewerUrl, setViewerUrl] = useState("");

  useEffect(() => {
    const getPosts = async () => {
      var response = await FirebaseHelper.getAllDocs(wallpapersRef);
      parseWallpapers(response)
      setWallpapers(response)
      console.log("Wallpapers Fetched");

    }
    getPosts();
  }, [])

  const parseWallpapers = (wallpaperArray) => {
    var column1 = [];
    var column2 = [];
    for (let i = 0; i < wallpaperArray.length; i++) {
      if (i % 2 == 0) {
        column1.push(wallpaperArray[i])
      } else {
        column2.push(wallpaperArray[i])
      }
    }
    setWallpapersColumn1(column1);
    setWallpapersColumn2(column2);
  }

  const ImageClick = (e,wallpaper) => {
    setViewerWallpaper(wallpaper)
    setViewerUrl(e.target.src)
    setVisible(true)
  }


  return (
    <div className='wallpapers-page'>
      <h1>WALLPAPERS</h1>
      <div className='wallpapers-container'>
        <div className='wallpapers-column'>
          {
            wallpapersColumn1 && wallpapersColumn1.map((wallpaper) => {
              return(
                <Image key={wallpaper.id} path="Wallpapers" id={wallpaper.id} type="" onClick={(e)=>{ImageClick(e,wallpaper)}}/>
              );
            })
          }
        </div>
        <div className='wallpapers-column'>
          {
            wallpapersColumn2 && wallpapersColumn2.map((wallpaper) => {
              return(
                <Image key={wallpaper.id} path="Wallpapers" id={wallpaper.id} type="" onClick={(e)=>{ImageClick(e,wallpaper)}}/>
              )
            })
          }
        </div>
      </div>
      <ImageViewer visible={visible} setVisibility={setVisible} url={viewerUrl} wallpaper={viewerWallpaper}/>
    </div>
  )
}

export default WallpapersPage